import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Ponto, PontoDeslocamento} from "./ponto.model";
import {apiName, apiNamePontosDeslocamento} from "./data.service";

@Injectable()
export class PontoApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Ponto, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Ponto, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"descricao","include":[{"endereco":[{"cidade":"estado"},"tipoLogradouro"]}]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllActive(done: any) {
        let filter: any = {"where":{"ativo":true},"order":"nome"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":[{"endereco":[{"cidade":"estado"},"tipoLogradouro"]}]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //pontos deslocamentos
    onPostPontoDeslocamento(object: PontoDeslocamento, done: any) {
        this._restService.onPost(apiNamePontosDeslocamento, object, done);
    }

    onPutPontoDeslocamento(object: PontoDeslocamento, done: any) {
        this._restService.onPut(apiNamePontosDeslocamento, object, done);
    }

    onDeletePontoDeslocamento(objectId: number, done: any) {
        this._restService.onDelete(apiNamePontosDeslocamento, objectId, done);
    }

    onGetPontoDeslocamento(filter: any, done: any) {
        filter.include = ["deslocamento","ponto"];
        this._restService.onGetPost(apiNamePontosDeslocamento, filter, done);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/shared/ponto-api.service.ts
 **/